var _path, _path2, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#de2910",
    d: "M0 0h30v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffde00",
    d: "m5 2 .9 2.75h2.9L6.45 6.4l.9 2.75L5 7.45 2.65 9.15l.9-2.75L1.2 4.75h2.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 3,
    r: 1,
    fill: "#ffde00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 6,
    r: 1,
    fill: "#ffde00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 10,
    r: 1,
    fill: "#ffde00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 1,
    fill: "#ffde00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.cc28f9e2bf1d5e3db2bbc1e05ad7eb2c.svg";
export { ForwardRef as ReactComponent };